import { useRef, useState } from "react"
import { useSearchParams, useLocation } from "react-router-dom"
import { SectionHeading, TableCustom, WrapperAdvancedSearch, FooterButtonVolver } from "../../components/common"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import { useEntidad } from "../../components/hooks/useEntidad"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { getDateNow } from "../../utils/convert"
import { isNull } from "../../utils/validator"
import IncisoVehiculoModal from "../../components/controls/IncisoVehiculoModal"
import IncisoVehiculoEmisionDefinicionGrid from "../../components/controls/IncisoVehiculoEmisionDefinicionGrid"
import { PERMISSIONS } from "../../consts/permissions"
const IncisoVehiculosView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()
    const location = useLocation()
    const previousFilters = location.state?.filters

    const [tableVisible, setTableVisible] = useState(false)
    const [incisos, setIncisos] = useState([])
    const [listIncisoVehiculoEmisionDefinicion, setListIncisoVehiculoEmisionDefinicion] = useState([])
    const [editMode, setEditMode] = useState()
    const [editItem, setEditItem] = useState()

    const searchRef = useRef()
    
    const { hasPermission } = usePermissions();
    const [search] = useSearchParams();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);
    const isViewOnly = search.get('mode') === OPERATION_MODE.VIEW;
    const allowEditActions = canEdit && !isViewOnly;

    const [getListEntidad] = useEntidad({
        entidades: ['EmisionDefinicion'],
        onLoaded: (_entidades, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
        },
        memo: null,
    });

    const filterData = (data) => {
        const { codigo, nombre, codigoSucerp, vehiculoMenor } = searchRef.current.filters

        let filtered = [...data]

        if (codigo !== '') filtered = filtered.filter(item => item.codigo.toLowerCase() === codigo.toLowerCase())
        if (nombre !== '') filtered = filtered.filter(item => item.nombre.toLowerCase().includes(nombre.toLowerCase()))
        if (codigoSucerp !== '') filtered = filtered.filter(item => item.codigoSucerp.toLowerCase() === codigoSucerp.toLowerCase())
        if (vehiculoMenor) filtered = filtered.filter(item => item.vehiculoMenor)

        return filtered
    }

    const SearchIncisoVehiculoEmisionDefiniciones = () => {
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.INCISO_VEHICULO,
            `/emision-definicion`,
            null,
            res => res.json().then(data => {
                data.forEach(x => {
                    if (x.fechaDesde) x.fechaDesde = new Date(x.fechaDesde);
                    if (x.fechaHasta) x.fechaHasta = new Date(x.fechaHasta);
                });
                setListIncisoVehiculoEmisionDefinicion(data);
            }),
            res => onRequestNoSuccess(res),
            err => onRequestError(err),
        )
    }

    const getEmisionDefinicionActual = (idIncisoVehiculo) => {
        const today = getDateNow();
        if (listIncisoVehiculoEmisionDefinicion.length === 0) return '';
        const vinculosDelInciso = listIncisoVehiculoEmisionDefinicion.filter(f => f.idIncisoVehiculo === idIncisoVehiculo);
        const actual = vinculosDelInciso.find(x =>
            (x.fechaDesde <= today || isNull(x.fechaDesde)) &&
            (x.fechaHasta >= today || isNull(x.fechaHasta))
        );
        if (!isNull(actual)) {
            const emisionDefinicion = getListEntidad('EmisionDefinicion').find(f => f.id === actual.idEmisionDefinicion);
            if (emisionDefinicion) return `${emisionDefinicion.descripcion} (${emisionDefinicion.periodo})`;
        }
        return '';
    };

    const SaveIncisoVehiculoEmisionDefinicion = (paramsUrl, dataBody) => {
        setIsLoading(true);
        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.INCISO_VEHICULO,
            paramsUrl,
            dataBody,
            res => res.json().then(() => {
                SearchIncisoVehiculoEmisionDefiniciones();
                setIsLoading(false);
            }),
            res => { onRequestNoSuccess(res); setIsLoading(false); },
            err => { onRequestError(err); setIsLoading(false); },
        );
    };

    const ActionIncisoVehiculoEmisionDefinicion = (row) => {
        const action = row.state;
        delete row.state;
        if (action === 'a') SaveIncisoVehiculoEmisionDefinicion(`/${row.idIncisoVehiculo}/emision-definicion/bind`, row);
        else if (action === 'r') SaveIncisoVehiculoEmisionDefinicion(`/${row.idIncisoVehiculo}/emision-definicion/unbind`, row);
    };

    const Search = () => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.INCISO_VEHICULO,
            null,
            null,
            res => res.json().then(data => {
                setIncisos(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
                SearchIncisoVehiculoEmisionDefiniciones()
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.INCISO_VEHICULO,
            `/${id}`,
            null,
            () => {
                Search()
                setIsLoading(false)
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const onModalCancel = () => {
        setEditItem(null)
        setEditMode(null)
    }

    const onModalConfirm = () => {
        setEditItem(null)
        setEditMode(null)
        if (tableVisible) Search()
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                nombre: '',
                orden: '',
                vehiculoMenor: false,
                codigoSucerp: '',
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el registro?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    return <>
        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Incisos de vehículos' }]}
                       onAddClick={allowEditActions ? avmr.onAdd : null} {...{tableVisible}} />

        <section className="section-accordion">
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 2, searchOnEnter: true, },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 4, searchOnEnter: true, },
                    { title: 'Código Suats', field: 'codigoSucerp', type: 'string', size: 2, searchOnEnter: true, },
                    {
                        title: 'Tipo de vehículo',
                        field: 'vehiculoMenor',
                        type: 'segmented',
                        size: 3,
                        options: [
                            { value: null, label: 'Todos' },
                            { value: true, label: 'Vehículo menor' },
                        ],
                    },
                ]}
                onSearch={Search}
            />

            {tableVisible && (
                <TableCustom
                    showFilterGlobal={false}
                    className={'TableCustomBase m-top-20'}
                    data={incisos}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    disabled={!allowEditActions}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        {
                            Header: '', id: 'expander', width: '3%', disableGlobalFilter: true, disableSortBy: true,
                            Cell: ({ row }) => (
                                <div className="action" {...row.getToggleRowExpandedProps({ title: 'ver historial de cambios' })}>
                                    <div className="link">
                                        {row.isExpanded
                                            ? <span className="material-symbols-outlined icon-expanded">expand_more</span>
                                            : <span className="material-symbols-outlined">chevron_right</span>
                                        }
                                    </div>
                                </div>
                            ),
                        },
                        { Header: 'Código', accessor: 'codigo', width: '15%' },
                        { Header: 'Nombre', accessor: 'nombre', width: '35%' },
                        { Header: 'Código Suats', accessor: 'codigoSucerp', width: '25%' },
                        {
                            Header: 'Definición de emisión actual',
                            id: 'emisionActual', accessor: 'id', width: '22%',
                            Cell: (props) => getEmisionDefinicionActual(props.row.original.id),
                        },
                    ]}
                    subComponent={({ row }) => (
                        <div className="form-sub-component">
                            <div className="row">
                                <div className="col-12 col-lg-8 p-top-15">
                                    <label className="form-label">Historial de cambios</label>
                                    <IncisoVehiculoEmisionDefinicionGrid
                                        disabled={!allowEditActions}
                                        data={{
                                            idIncisoVehiculo: row.original.id,
                                            list: listIncisoVehiculoEmisionDefinicion.filter(f => f.idIncisoVehiculo === row.original.id)
                                        }}
                                        onChange={ActionIncisoVehiculoEmisionDefinicion}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                />
            )}

            {editItem && (
                <IncisoVehiculoModal
                    {...{editMode, editItem}}
                    onCancel={onModalCancel}
                    onConfirm={onModalConfirm}
                />
            )}
        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
    </>
}

export default IncisoVehiculosView
